// extracted by mini-css-extract-plugin
export default {"savedCard":"ld31VqZ9Rzdiqpdhrmc1"};